import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.icon};
`;

const LeftArrow = props => {
  if (window.innerWidth > 1800)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33.416"
        height="28.001"
        viewBox="0 0 33.416 28.001"
        {...props}
      >
        <G transform="rotate(180 709.282 62.397)" fill="none" strokeWidth="2">
          <path
            d="M0,26.587,13.294,13.294,0,0"
            transform="translate(1403.854 97.5)"
            strokeMiterlimit="10"
          />
          <line x1="31.111" y1="0.07" transform="translate(1385.148 110.587)" />
        </G>
      </svg>
    );
  else
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20.584"
        height="17.221"
        viewBox="0 0 20.584 17.221"
      >
        <G transform="rotate(180 10.291 8.434)" fill="none">
          <path
            d="M0,0,8.257,8.257,0,16.514"
            transform="translate(11.619)"
            strokeMiterlimit="10"
          />
          <line x1="19.323" y2="0.043" transform="translate(0 8.342)" />
        </G>
      </svg>
    );
};

export default LeftArrow;
